// extracted by css-extract-rspack-plugin
export default {"superCar":"superCar-dsMlQX","loadAnimation":"loadAnimation-LFiIOn"};